import PropTypes from "prop-types"
import CertificationContent from "~/components/Certifications/CertificationContent"
import CertificationDetails from "~/components/Certifications/CertificationDetails"
import UnsavedChanges from "~/components/Certifications/UnsavedChanges"
import CourseLessonContentContainer from "~/components/Common/CourseLessonContentContainer"
import Page from "~/pages/Page"
import Router from "~/router"

import Box from "../../../../../../components/Common/Box"
import useStyles from "./styles"

const Content = ({ routes = [], ...rest }) => {
  const classes = useStyles()

  return (
    <Page>
      <Box className={classes.container}>
        <CourseLessonContentContainer
          leftComponent={<CertificationDetails />}
          rightComponent={<CertificationContent />}
        />
        <Router routes={routes} {...rest} />
        <UnsavedChanges />
      </Box>
    </Page>
  )
}

Content.propTypes = {
  routes: PropTypes.array,
}

export default Content
